import ui          from './ui';
import lesson      from './lesson';
import activity    from './activity';

export default {

	...ui,
	...lesson,
	...activity

};
